import LockTab from './LockTab'
export default LockTab


// WEBPACK FOOTER //
// ./src/components/ChannelTabs/OmnitecTab/MappingTabs/LockTab/index.js